<template>
  <div class="page-404" v-if="show">
    <i class="page-404-icon"></i>
    <p class="page-404-text">出错啦 ？访问页面不存在</p>
    <div class="page-404-back">
      <a @click="back" class="page-404-back-button" href="javascript:;">返回</a>
    </div>
  </div>
</template>

<script>
import api from '@edu-fe/api'

export default {
  data () {
    return {
      show: true
    }
  },

  methods: {
    back () {
      this.$router.back()
    }
  },

  async beforeRouteEnter (toRoute, fromRoute, next) {
  // async beforeCreate () {
    // const { path, hash, query } = this.$route
    const { path, hash, query } = toRoute
    const from = query.from

    // edu-m 我的
    // https://edu-m.wps.cn/mine.html?tab=0&_=68058
    if (path === '/mine.html') {
      return next({
        name: 'mine',
        query: {
          from
        }
      })
    }

    // edu-m 视频详情
    // http://edu-m.wps.cn/detail.html?cid=ab3451b6e62411e7af1cfa163e0ce510&market=m_recommend&_origin=limitedspecial&_=37757
    if (path === '/detail.html') {
      const { cid: courseId } = query
      return next({
        name: 'sign-up',
        query: {
          courseId,
          from
        }
      })
    }

    // edu-school 详情页
    // https://edu-m.wps.cn/course/id/026db94e237811e88263fa163e3b12eb/keynote
    if (path.match(/^\/course\/id\//)) {
      const chapterId = path.split('/')[3]
      const { data: courseId } = await api.course.getCourseId({ chapterId })
      const { data: type } = await api.course.getType({ courseId })
      const name = ['', 'video-detail', 'audio-detail'][type]
      return next({
        name,
        query: {
          courseId,
          chapterId,
          from
        }
      })
    }

    // edu-m 列表页
    // http://edu-m.wps.cn/#/list/2311fb08a65311e6aed8fa163e422c00/0
    if (path === '/' && hash.match(/^#\/list/)) {
      const id = hash.split('/')[2]
      const { data: list } = await api.category.get()
      const category = Math.max(list.map(item => item.id).indexOf(id), 0)
      return next({
        name: 'list',
        query: {
          category,
          from
        }
      })
    }
    // http://edu-m.wps.cn/daily.html?_=77962

    // edu-m 每日技巧
    // http://edu-m.wps.cn/#/daily-detail/e1587cc54ab611e8813efa163e0ce510
    if (path === '/' && hash.match(/^#\/daily(-detail)?/)) {
      const courseId = hash.split('/')[2] || 'null'
      if (!fromRoute.name) {
        return next({
          name: 'free_video_main',
          params: {
            courseId
          },
          query: {
            from
          }
        })
      }
    }
    // http://edu-m.wps.cn/daily.html?_=77962
    // http://edu-m.wps.cn/daily.html?id=1cf8f0ae78e011e7a335fa163e2a3b23&_=41925
    if (path === '/daily.html') {
      return next({
        name: 'free_video_main',
        params: {
          courseId: 'null'
        },
        query: {
          from
        }
      })
    }

    // edu-school 报名页面
    // https://edu-m.wps.cn/course/list/signing?from=wx_app_course_btn // 报名中
    // https://edu-m.wps.cn/course/list/signed // 已报名
    if (path.match(/^\/course\/list\//)) {
      const type = path.split('/')[3]
      const name = {
        signing: 'recommend',
        signed: 'mine'
      }[type]
      return next({
        name,
        query: {
          from
        }
      })
    }

    // edu-school 分享页面
    // https://edu-m.wps.cn/course/video-share/7ef73da9d35911e7af1cfa163e0ce510/16/http%3A%2F%2Fwx.qlogo.cn%2Fmmopen%2Fvi_32%2FajNVdqHZLLAO73VkAtIJotTGBNW2P3N5W5qrfIM9rPrceQNStWS1FSudK9pSb7n9W4GwX5krfuwtm54I0ypZog%2F0?from=timeline&isappinstalled=0
    if (path.match(/^\/course\/video-share\//)) {
      return next({
        name: 'recommend',
        query: {
          from
        }
      })
    }

    // edu-school 报名页面
    // https://edu-m.wps.cn/course/sign-up/4451f516574611e8813efa163e0ce510?from=wx_app_course_btn
    if (path.match(/^\/course\/sign-up\//)) {
      const courseId = path.split('/')[3]
      return next({
        name: 'sign-up',
        query: {
          courseId,
          from
        }
      })
    }

    // edu-school 课程表页面
    // https://edu-m.wps.cn/course/timetable/4451f516574611e8813efa163e0ce510?isNew=1
    if (path.match(/^\/course\/timetable\//)) {
      const courseId = path.split('/')[3]
      return next({
        name: 'schedule',
        query: {
          courseId,
          from
        }
      })
    }

    // edu-school 赠送页面
    // https://edu-m.wps.cn/course/present/372748e7624b11e8813efa163e0ce510
    if (path.match(/^\/course\/present\//)) {
      const shareId = path.split('/')[3]
      return next({
        name: 'gift',
        query: {
          shareId,
          from
        }
      })
    }

    // edu-m 首页
    if (path === '/') {
      return next({
        name: 'recommend',
        query: {
          from
        }
      })
    }

    // 404
    next()
    // this.$nextTick(() => (this.show = true))
    // this.show = true
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";
.page-404 {
  position: absolute;
  left: 0;
  right: 0;
  top: use(396);
  &-icon {
    display: block;
    margin: 0 auto;
    width: use(256);
    height: use(135);
    background: url('../assets/images/404.png');
    background-size: 100% 100%;
    margin-bottom: use(69);
  }
  &-text {
    font-size: use(26);
    color: #999;
    text-align: center;
    margin-bottom: use(30);
  }
  &-back {
    text-align: center;
    &-button {
      display: inline-block;
      width: use(140);
      font-size: use(26);
      @include height(50);
      border-radius: use(5);
      border: 1px solid #C5A404;
      color: #C5A404;
    }
  }
}
// .404 {}
</style>
